import React from "react";
import "./SupportAndConsultingPage.css";
import BannerImage from "../../../assets/other_image/supportNEw.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import SupportAndConsultingOverview from "./SupportAndConsultingOverview";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const SupportAndConsultingPage = () => {
  return (
    <section className="SupportAndConsultingprocess">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Support And Consulting" // Pass the heading text for this page
      />
<FloatingContactUs />
      <SupportAndConsultingOverview/>

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Support And Consulting with NexTech!
          </h5>
      
          <ul className="custom-bullets">
            <li>Teamcenter usage related day-to-day to issue resolution.</li>
            <li>Troubleshooting and guiding the users for various activities. </li>
            <li>Providing support to interface applications linked to Teamcenter like S,E, MSO etc </li>
            <li>Enabling best practices for using Teamcenter PLM </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <h4 className="solution-page-heading">Our Solutions</h4>
          <ul className="custom-bullets">
            <li>Onsite Support </li>
            <li>Off shore support </li>
            <li>24*7 support system </li>
            <li>On call support </li>
            <li>Support with full ownership </li>
          </ul>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">
            For Support and Consulting Solution 
          </h5>
          <ul className="custom-bullets">
            <li>
            Seamless resolution of Teamcenter usage-related issues and comprehensive troubleshooting guidance for various activities, ensuring uninterrupted PLM operations.  
            </li>
            <li>
            Expert support provided for interface applications linked to Teamcenter, such as S, E, MSO, etc., facilitating smooth integration and data exchange across the PLM ecosystem. 
            </li>
            <li>
            Implementation of best practices for utilizing Teamcenter PLM, optimizing system performance and enhancing user productivity.  
            </li>
            <li>
            Flexible support options including onsite, offshore, 24*7 availability, and on-call support, catering to diverse business needs and ensuring continuous assistance and problem-solving. 
            </li>
            <li>
            Support services with full ownership, guaranteeing dedicated attention and proactive management of PLM systems to maximize reliability, availability, and performance.  
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
    </section>
  );
};

export default SupportAndConsultingPage;
